<template>
  <!-- Appearance -->
  <v-list-subheader data-test-id="navigation-menu-theme-cta-title">Appearance</v-list-subheader>

  <v-btn-toggle
    id="theme-selector"
    variant="outlined"
    class="w-100"
    mandatory
    divided
    v-model="theme"
    :rounded="UI.BORDER_RADIUS"
  >
    <v-btn
      value="light"
      icon="bi-sun"
      aria-label="Light theme"
      data-test-id="navigation-menu-theme-cta-light"
      class="flex-grow-1"
      v-tooltip="{ text: 'Light', location: 'top' }"
    />

    <v-btn
      value="dark"
      icon="bi-moon"
      aria-label="Dark theme"
      data-test-id="navigation-menu-theme-cta-dark"
      class="flex-grow-1"
      v-tooltip="{ text: 'Dark', location: 'top' }"
    />

    <v-btn
      value="system"
      icon="bi-circle-half"
      aria-label="System theme"
      data-test-id="navigation-menu-theme-cta-system"
      class="flex-grow-1"
      v-tooltip="{ text: 'System', location: 'top' }"
    />
  </v-btn-toggle>
</template>

<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useTheme } from 'vuetify';

import { UI } from '@/layouts/constants/Layout';

const vuetifyTheme = useTheme();
const selectedTheme = ref(localStorage.getItem('theme') || vuetifyTheme.global.name.value);
const systemThemeQuery = window.matchMedia('(prefers-color-scheme: dark)');

const getSystemTheme = () => (systemThemeQuery.matches ? 'dark' : 'light');

const applySystemTheme = () => {
  if (selectedTheme.value === 'system') {
    vuetifyTheme.change(getSystemTheme());
  }
};

const theme = computed({
  get: () => selectedTheme.value,
  set: (value) => {
    selectedTheme.value = value;
    localStorage.setItem('theme', value);
    // Set transition origin to the theme selector so the theme transition animates from this control
    // Transition of theme start from the appearance button
    const origin = document.getElementById('theme-selector');
    if (origin) {
      vuetifyTheme.setTransitionOrigin(origin);
    }
    vuetifyTheme.change(value === 'system' ? getSystemTheme() : value);
  },
});

onMounted(() => systemThemeQuery.addEventListener('change', applySystemTheme));
onBeforeUnmount(() => systemThemeQuery.removeEventListener('change', applySystemTheme));
</script>
